import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function WaitList () {
  const navigate = useNavigate();




  return (
    <div className="min-h-[var(--app-height,100dvh)] overflow-y-auto overscroll-contain bg-[#F3F0FF] flex items-start sm:items-center justify-center px-4 py-6 sm:py-8">
      <div className="w-full max-w-[520px] p-6 sm:p-8 md:p-10">
        {/* Logo + Title */}
        <div className="flex flex-col items-center gap-4 mb-8">
          <div className="h-20 w-20 rounded-xl bg-gradient-to-br from-[#7C4DFF] to-[#6A35FF] flex items-center justify-center shadow-md">
            <img src="./logo.svg" alt=" PhoneBookPlus Logo" />
          </div>
          <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-gray-500 font-inter">
             PhoneBookPlus
          </h1>
        </div>

        <div className="space-y-6">
          <div className="text-2xl text-[#475467] font-medium text-center">
            Thanks for joining! You’re in the waiting list.
          </div>
            <p className="text-[#475467] font-medium text-center">
Have an invitation code? Add it to skip the waiting list.</p>


          <div className="space-y-5">
            {/* <button
              type="button"
              className="submit-button flex justify-center items-center w-full bg-gradient-to-r from-[#7C4DFF] to-[#6A35FF] text-white font-semibold py-3 rounded-xl shadow-md hover:opacity-90"
            >
              + Waiting List
            </button> */}

            <button
              type="button"
              onClick={() => navigate("/invitation-code", { replace: true })}
              className="submit-button flex justify-center items-center w-full bg-white text-[#6A35FF] border border-[#6A35FF] font-semibold py-3 rounded-xl hover:bg-[#F3F0FF] transition"
            >
              Enter Invitation Code
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
